export default __webpack_public_path__ + "static/media/VIDEO.29d4fdf4.jpg";